import gql from "graphql-tag";

const caseFieldsFragment = gql`
	fragment CaseFieldsFragment on Case {
		id
		sourceTenantId
		actualAgreementId
		documentStatus
		relevantArticle71Indication {
			id
			name
		}
		baseAgreement {
			initialVersionId
			isHidden
			allowedForms
			currency {
				Code
				Name
			}
			negotiableAttributes {
				identifier
			}
			enrollingConditionSets {
				conditions {
					conditionType
					rating
					therapyDecision
				}
				isIndicationNotEnrollingCondition
				isDiseaseNotEnrollingCondition
			}
		}
		flexEntitiesConnection(where: { node: { isDeleted: false } }) {
			edges {
				isStartingPoint
				node {
					id
					createdOn
					status
					data
					type {
						id
					}
				}
			}
		}
		canUserViewFinancials
		negotiationRounds {
			status
			updatedBy {
				id
			}
			source {
				id
				createdOn
			}
			data
		}
	}
`;

export const GET_FLEX_ENTITY_TYPE_BY_ID = gql`
	query GetFlexEntityTypeById($id: ID!) {
		flexEntityTypes(where: { id: $id }) {
			id
			name
			localizationKey
			containerType
			isStartingPoint
			ignoredAttributes
			features
			data
			catalogueAttributes {
				id
				identifier
			}
		}
	}
`;

export const GET_FLEX_ENTITY_TYPE_AND_CASES_BY_ID = gql`
	${caseFieldsFragment}

	query GetFlexEntityTypeAndCasesById($id: ID!, $caseIds: [ID!]!) {
		flexEntityTypes(where: { id: $id }) {
			id
			name
			features
			localizationKey
			containerType
			isStartingPoint
			data
			ignoredAttributes
			catalogueAttributes {
				id
				identifier
			}
		}

		cases(where: { id_IN: $caseIds, status_IN: [TENTATIVE, ACTIVE, IN_REVIEW, SUSPENDED, ARCHIVED], isDeleted: false }) {
			...CaseFieldsFragment
		}
	}
`;

export const GET_FLEX_ENTITY_AND_TYPE_BY_INSTANCE_ID = gql`
	${caseFieldsFragment}

	query GetFlexEntityAndTypeByInstanceId($id: ID!) {
		flexEntities(where: { id: $id, isDeleted: false }) {
			id
			tenantId
			createdOn
			data
			status
			cases(
				where: {
					isDeleted: false
					isArchived: false
					status_IN: [TENTATIVE, ACTIVE, IN_REVIEW, SUSPENDED, ARCHIVED]
					baseAgreement: { isHidden: false, isDeleted: false }
				}
			) {
				...CaseFieldsFragment
			}
			financialDataPoints {
				generatedFor(
					where: {
						isDeleted: false
						isArchived: false
						status_IN: [TENTATIVE, ACTIVE, IN_REVIEW, SUSPENDED, ARCHIVED]
						baseAgreement: { isHidden: false, isDeleted: false }
					}
				) {
					...CaseFieldsFragment
				}
				agreement(where: { isDeleted: false, isArchived: false, isHidden: false, isCaseless: true }) {
					id
					initialVersionId
					isCaseless
				}
				sourceRefund {
					status
				}
				evaluationSnapshot
			}
			type {
				id
				name
				features
				containerType
				isStartingPoint
				ignoredAttributes
				data
				localizationKey
				catalogueAttributes {
					id
					identifier
				}
			}
			successor {
				id
			}
			predecessor {
				id
			}
			createdBy {
				id
				email
				firstName
				lastName
			}
		}
	}
`;

export const GET_IMPOSSIBLE_TO_EDIT_ATTRIBUTES = gql`
	query GetImpossibleToEditAttributes($id: ID!) {
		GetImpossibleToEditAttributes(formId: $id) {
			identifier
			row
		}
	}
`;
